import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import {
  KeyboardArrowLeft,
} from '@material-ui/icons';
import {
  inject, observer,
} from 'mobx-react';
import {
  WithSnackbarProps,
} from 'notistack';
import React, {
  Component,
} from 'react';
import {
  RouteComponentProps, withRouter,
} from 'react-router';
import * as Yup from 'yup';
import {
  FormField,
} from '../../components/GeneralCRUDComponent/FormFields/formFields';
import GeneralFormComponent from '../../components/GeneralCRUDComponent/GeneralFormComponent/GeneralFormComponent';
import SnackBarComponent from '../../components/SnackBarComponent/SnackBarComponent';
import Spinner from '../../components/Spinner';
import {
  getDropdownLanguagesList, languageCodes,
} from '../../constants/languages';
import {
  translate,
} from '../../helperFunctions/translation';
import {
  ICountry,
} from '../../mobx-store/storeInterfaces/authInterface';
import {
  CountryStore,
} from '../../mobx-store/stores/countryStore';
import classes from './addEditFacilityArea.module.scss';
import {
  IFacilitiesAreasStore,
} from '../../mobx-store/storeInterfaces/facilityAreaInterface';
import { IBranchStore } from '../../mobx-store/storeInterfaces/branchInterface';
import { countriesIsoCodes } from '../../constants/countries';

interface IProps extends WithSnackbarProps {
  facilityAreaStore: IFacilitiesAreasStore;
  countryStore: CountryStore;
  branchStore: IBranchStore;
  match: any;
  history: any;
}

interface IState {
  formFields: FormField[];
  loading: boolean;
  loadingManagedCountries: boolean;
  processing: boolean;
  selectedLang: string;
  loadingBranches: boolean;
}

@inject('facilityAreaStore', 'branchStore')
@inject('countryStore')
@observer
export class AddEditFacilityArea extends Component<IProps & RouteComponentProps, IState> {
  isNew = false;

  isEgypt = false;

  facilityAreaId = -1;

  pageTitle = '';

  lastHistory = -1;

  facilityAreaFormTitle = '';

  facilityAreaSchema: any;

  submitButton: any;

  cancelButton: any;

  dropdownLanguages: {
    langList: {langCode: string; langValue: string} [];
    selectedLang: string;
    label: string;
    onChange(langCode: string): any;
  } | null = null;

  constructor(props: IProps & RouteComponentProps) {
    super(props);
    this.initializeComponent(props);
  }

  initializeComponent(props: IProps & RouteComponentProps, isConstructor = true) {
    if (props.match.params.id) {
      this.isNew = false;
      this.facilityAreaId = props.match.params.id;
      this.pageTitle = translate('editFacilityAreaPageTitle', {
      });
    } else {
      this.isNew = true;
      this.pageTitle = translate('addFacilityAreaPageTitle', {
      });
    }
    this.initfacilityAreaSchema();
    this.initState(isConstructor);
    this.submitButton = this.getSubmitButton();
    this.cancelButton = this.getCancelButton();
    this.facilityAreaFormTitle = translate('facilityAreaFormTitle', {
    });
    this.dropdownLanguages = this.getDropdownLanguages();
  }

  getDropdownLanguages = () => {
    if (this.isNew) {
      return null;
    }
    return {
      langList: getDropdownLanguagesList(),
      selectedLang: this.state.selectedLang,
      label: 'Select Languages',
      onChange: this.handelLanguageChange,
    };
  };

  async componentWillReceiveProps(nextProps: IProps & RouteComponentProps) {
    if (this.props.location.pathname !== nextProps.location.pathname) {
      this.lastHistory = -2;
      this.initializeComponent(nextProps, false);
      this.forceUpdate();
      await this.props.countryStore.getUserManagedCountries();
      if (this.props.countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
        this.isEgypt = true;
      }
      this.setState({
        loadingManagedCountries: false,
      });
      if (!this.isNew) {
        this.props.facilityAreaStore.getFacilityAreaById(this.facilityAreaId, languageCodes.english)
          .then(() => {
            this.updateStateWithFacilityAreaData();
          }).catch(() => {
            this.setState({
              loading: false, selectedLang: languageCodes.english
            });
          });
          this.dropdownLanguages = this.getDropdownLanguages();
      }
      this.props.branchStore.getBranches(this.props.countryStore.managedCountries)
        .then(() => {
          this.updateStateWithBranchesData();
        }).catch(() => {
          this.setState({
            loadingBranches: false,
          });
        });
    }
  }

  handelLanguageChange = (langCode: string) => {
    if (this.isNew) {
      this.setState({
        selectedLang: langCode,
      });
    } else {
      this.getFacilityArea(langCode);
    }
  };

  initfacilityAreaSchema = () => {
    this.facilityAreaSchema = Yup.object().shape({
      title: Yup.string()
        .required('Required'),
      branchId: Yup.number().required('Required'),
    });
  };
  getFormFields = ():FormField[] => {
   return  [
      {
        name: 'title',
        label: translate('title'),
        type: 'text',
        filedType: 'InputField',
      },
      {
        name: 'branchId',
        label: translate('addFacilityAreaPageFormAvailableBranches', {
        }),
        selectList: [],
        selectListValue: 'title',
        selectListKey: 'id',
        filedType: 'DropdownField',
      },
    ]
  }
  initState = (isConstructor = true) => {
    const initState: IState = {
      selectedLang: this.isNew ? languageCodes.arabic : languageCodes.english,
      processing: false,
      loadingManagedCountries: true,
      loadingBranches: true,
      loading: !this.isNew,
      formFields: this.getFormFields(),
    };
    if (isConstructor) {
      this.state = initState;
    } else {
      this.setState(initState);
    }
  };

  navigateBack = () => {
    this.props.history.goBack();
  };

  handleSubmit = (values: any): void => {
    const {
      countryStore,
    } = this.props;
    values.availableCountries = countryStore.managedCountries.map((country: ICountry) => country.isoCode);

    this.setState({
      processing: true,
    });
    if (this.isNew) {
      try {
        this.props.facilityAreaStore.createFacilityArea(values)
          .then((facilityAreaId) => {
            if (this.isEgypt) {
              this.props.history.push(`${facilityAreaId}/edit`);
            } else {
              this.props.history.go(this.lastHistory);
            }
          });
      } catch {
        this.setState({
          processing: false,
        });
        SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
        }), 5000, 'error');
      }
    } else {
      this.props.facilityAreaStore.updateFacilityArea(values, this.facilityAreaId, this.state.selectedLang)
        .then(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('updatedMessage', {
          }), 5000, 'success');
          this.props.history.go(this.lastHistory);
        }).catch(() => {
          this.setState({
            processing: false,
          });
          SnackBarComponent.getInstance().openSnackbar(translate('errorMessage', {
          }), 5000, 'error');
        });
    }
  };

  getSubmitButton = () => ({
    title: (this.isNew && this.isEgypt ? 'To Next Language' : 'Save Changes'),
    onSubmit: this.handleSubmit,
  });

  getCancelButton = () => ({
    title: 'Cancel',
    onCancel: this.navigateBack,
  });

  updateStateWithFacilityAreaData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      formFieldsWithData.push({
        ...field, value: this.props.facilityAreaStore.selectedFacilityArea[field.name],
      });
    }
    this.setState({
      formFields: formFieldsWithData, loading: false,
    });
  };

  getFormPageHeader = () => (
    <div className={classes.header}>
      <IconButton
        className={classes.backButton}
        onClick={() => this.props.history.goBack()}
        aria-label="Back"
      >
        <KeyboardArrowLeft />
      </IconButton>
      <Typography className={classes.title} variant="h6" gutterBottom>
        {this.pageTitle}
      </Typography>
    </div>
  );

  render() {
    return (
      <div className={classes.container}>
        {this.getFormPageHeader()}
        <div className={classes.content}>
          {this.state.loading || this.state.loadingBranches || this.state.loadingManagedCountries
            ? <Spinner />
            : (
              <GeneralFormComponent
                dropdownLanguages={this.isEgypt ? this.dropdownLanguages : null}
                formTitle={this.facilityAreaFormTitle + ' ' + this.state.selectedLang.toUpperCase()}
                fields={this.state.formFields}
                formSchema={this.facilityAreaSchema}
                submitButton={this.submitButton}
                cancelButton={this.cancelButton}
                processing={this.state.processing}
              />
            )}
        </div>
      </div>
    );
  }

  async componentDidMount() {
    const {
      countryStore, facilityAreaStore, branchStore
    } = this.props;
    await countryStore.getUserManagedCountries();
    if (countryStore.managedCountries.some((country: ICountry) => country.isoCode === countriesIsoCodes.egypt)) {
      this.isEgypt = true;
    }

    this.initState(false);
    this.submitButton = this.getSubmitButton();

    branchStore.getBranches(countryStore.managedCountries)
      .then(() => {
        this.updateStateWithBranchesData();
      }).catch(() => {
        this.setState({
          loadingBranches: false,
        });
      });

    this.setState({
      loadingManagedCountries: false,
    });

    if (!this.isNew) {
      facilityAreaStore.getFacilityAreaById(this.facilityAreaId, this.state.selectedLang)
        .then(() => {
          this.updateStateWithFacilityAreaData();
        }).catch(() => {
          this.setState({
            loading: false,
          });
        });
    }
  }

  updateStateWithBranchesData = () => {
    const formFieldsWithData = [];
    for (const field of this.state.formFields) {
      if (field.name === 'branchId') {
        formFieldsWithData.push({
          ...field, selectList: this.props.branchStore.branchesList,
        });
      } else {
        formFieldsWithData.push(field);
      }
    }
    this.setState({
      formFields: formFieldsWithData, loadingBranches: false,
    });
  };

  getFacilityArea = (langCode: string) => {
    const {
      countryStore, facilityAreaStore, branchStore
    } = this.props;
    this.setState({
      loading: true,
    });
    facilityAreaStore.getFacilityAreaById(this.facilityAreaId, langCode)
      .then(() => {
        this.updateStateWithFacilityAreaData();
        this.dropdownLanguages!.selectedLang = langCode;
        this.setState({
          selectedLang: langCode,
        });
      }).catch(() => {
        this.setState({
          loading: false,
        });
      });
      branchStore.getBranches(countryStore.managedCountries)
      .then(() => {
        this.updateStateWithBranchesData();
      }).catch(() => {
        this.setState({
          loadingBranches: false,
        });
      });
  };
}

export default withRouter(AddEditFacilityArea);
